module.exports = __webpack_public_path__ + "img/icon_benefit_01.0ac5d1e7.svg";